import { get } from 'lodash'
import { registerSpec } from '@xhs/yam-beer/theme/index.js'
import { css } from '../css.js'

export const registerThemeSpec = (
  scale,
  rule,
  override = true,
) => {
  if (override) {
    registerSpec(scale, rule, override)
  }
  return props => {
    let val = get(props.theme, scale)

    if (typeof val === 'function') {
      val = val(props)
    }
    return css(val)(props)
  }
}

export const registerThemeDocSpec = (name, rule) => ({
  name,
  rule,
})

export default registerThemeSpec
